import { Link } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

type BackButtonProps = {
  href: string;
  label?: string; // aria-label
};

export default function BackButton({ href, label = "رجوع" }: BackButtonProps) {
  const { dir } = useTheme() as { dir: "rtl" | "ltr" };
  const Icon = dir === "rtl" ? CaretRight : CaretLeft;

  return (
    <StyledLink to={href} aria-label={label}>
      <Icon size={22} weight="bold" />
    </StyledLink>
  );
}

const StyledLink = styled(Link)`
  position: absolute;
  inset-inline-start: 0; /* works for RTL/LTR */
  top: 50%;
  transform: translateY(-50%);
  height: 40px;
  width: 40px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--primary);
  text-decoration: none;
`;
